export default {"src":"/_next/static/media/lock-icon.000fa32b.svg","height":17,"width":17};